export default __webpack_public_path__ + "static/KFH25-003-service-card-right-1cf97b1c6c1a62295fdee7d327e83cba.jpg";